// extracted by mini-css-extract-plugin
export default {"produtos":"Produtos_produtos__D965I","nome":"Produtos_nome__STWue"};